import { QUOTATIONS_TABLE_SET_FILTERS } from 'Redux/types/tableQuotationsTypes';
import { DEFAULT_QUOTATION_FILTERS } from '@constants/quotationFilters';

// const initianStateFiltersTableQuotations = {
//   searchText: '',
//   branches: [],
//   advisors: [],
//   insuranceCarriers: [],
//   createdAtStart: null,
//   createdAtEnd: null,
//   updatedAtStart: null,
//   updatedAtEnd: null,
//   vehicleServiceTypes: [],
//   vehicleModelStart: null,
//   vehicleModelEnd: null,
// };

const filtersTableQuotations = (state = DEFAULT_QUOTATION_FILTERS, action) => {
  switch (action.type) {
    case QUOTATIONS_TABLE_SET_FILTERS:
      return ({
        ...state,
        ...action.payload,
        // text_search: action.text_search || '',
        // branches: action.branches || [],
        // vendedores: action.vendedores || [],
        // aseguradoras: action.aseguradoras || [],
        // final_created_at: action.final_created_at,
        // initial_created_at: action.initial_created_at,
        // updated_at_start: action.updated_at_start,
        // updated_at_end: action.updated_at_end,
        // vehicle_model_start: action.vehicle_model_start,
        // vehicle_model_end: action.vehicle_model_end,
      });

    default:
      return (state);
  }
};

export default filtersTableQuotations;
